import React, { useState } from "react";
import PropTypes from "prop-types";
import PopupPortal from "../../shared/common/PopupWindow";
import WithdrawForm from "./Withdraw/Form/WithdrawForm";
import { Link } from "gatsby";

const AccAccordion = ( { gameName, userName, logoutFunc } ) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closePopup = () => {
    setIsOpen(false);
  }

  return (
    <div className="acc-accordion" onMouseLeave={() => setIsMenuOpen(false)}>
      <div className={isMenuOpen ? "accordion-title button open" : "accordion-title button"}
           onMouseEnter={() => setIsMenuOpen(!isMenuOpen)}
           onClick={() => setIsMenuOpen(!isMenuOpen)}>บัญชีของฉัน</div>
      {isMenuOpen &&
      <div className="accordion-content">
        <div className="user">{userName}</div>
        <button type="acc-accordion-withdraw button" onClick={() => setIsOpen(true)} className="a">ถอนเงิน</button>
        <Link className="acc-accordion-terms-btn a" to="/freespin-terms-and-conditions/">ข้อกำหนดและเงื่อนไข</Link>
        <button className="acc-accordion-logout-btn logout" onClick={() => logoutFunc()}>ลงชื่อออก</button>
      </div>
      }
      <PopupPortal open={isOpen} onClose={() => closePopup()}>
        <WithdrawForm gameName={gameName}/>
      </PopupPortal>
    </div>
  );
}

export default AccAccordion;

AccAccordion.propTypes = {
  gameName: PropTypes.string,
  userName: PropTypes.string,
  logoutFunc: PropTypes.func
};
